import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../style/Header.css";
import { FaBars } from "react-icons/fa";
import logoImage from "../assets/logo-blasterc-blue.png";
import Notification from "./Notification-dropdown";
import Profile from "../pages/user/Profile";
import { fetchApi } from "../utils/api";
import notificationIcon from "../assets/icon/bell.png";
import notificationActiveIcon from "../assets/icon/bell-active.png";

const Header = ({ toggleSidebar }) => {
  const { logout, currentUser } = useAuth();
  const navigate = useNavigate();

  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [imageError, setImageError] = useState(false);

  const profileRef = useRef(null);
  const notificationRef = useRef(null);

  // 🔹 Logout handler
  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  // 🔹 Toggle dropdowns
  const toggleNotificationDropdown = () => {
    setShowNotifications((prev) => !prev);
    setShowProfile(false);
  };

  const toggleProfileDropdown = () => {
    setShowProfile((prev) => !prev);
    setShowNotifications(false);
  };

  // 🔹 Refresh notification data
  const refreshNotifications = () => {
    setLoading(true);
    let endpoint = "/notifications";
    if (currentUser?.role === "admin") {
      endpoint = "/notifications/admin";
    }

    fetchApi(endpoint)
      .then((data) => {
        setNotifications(data);
        const unread = data.filter((notif) => !notif.is_read).length;
        setUnreadCount(unread);
      })
      .catch((err) => console.error("Error refresh notifications:", err))
      .finally(() => setLoading(false));
  };

  // 🔹 Fetch unread count periodically
  const fetchUnreadCount = () => {
    fetchApi("/notifications/unread-count")
      .then((data) => setUnreadCount(data.count))
      .catch((err) => console.error("Error fetching unread count:", err));
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchUnreadCount();
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);

  // 🔹 Handle click outside (close dropdown)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 🔹 Auto-refresh notifications every 30s
  useEffect(() => {
    if (showNotifications) {
      refreshNotifications();
    } else {
      refreshNotifications();
      const intervalId = setInterval(() => {
        refreshNotifications();
      }, 30000);
      return () => clearInterval(intervalId);
    }
  }, [showNotifications]);

  // 🔹 Refresh header when profile updated
  useEffect(() => {
    const handleProfileUpdated = () => {
      console.log("📸 Header detected profile update, forcing re-render...");
      setImageError(false);
      // Force re-render with updated user from context
      setShowProfile(false);
      setTimeout(() => setShowProfile(true), 10);
    };

    window.addEventListener("profileUpdated", handleProfileUpdated);
    return () => window.removeEventListener("profileUpdated", handleProfileUpdated);
  }, []);

  return (
    <header className="topnav">
      <div className="left">
        <button className="menu-toggle" onClick={toggleSidebar}>
          <FaBars />
        </button>
        <img src={logoImage} alt="BLASTERC" className="logo-img" />
      </div>

      <div className="right">
        {/* 🔔 Notifikasi */}
        <div className="notification-wrapper" ref={notificationRef}>
<button 
  className="notification-icon" 
  onClick={toggleNotificationDropdown}
  title="Notifications"
>
  <img
    src={showNotifications ? notificationActiveIcon : notificationIcon}
    alt="Notifications"
    className="notification-icon-img"
  />
  
  {unreadCount > 0 && (
    <span className="notification-badge">
      {unreadCount > 99 ? "99+" : unreadCount}
    </span>
  )}
</button>
          {showNotifications && (
            <div className="notification-dropdown">
              <Notification
                notifications={notifications}
                loading={loading}
                refreshNotifications={refreshNotifications}
                onClose={() => setShowNotifications(false)}
              />
            </div>
          )}
        </div>

        {/* 👤 Profile Dropdown */}
        <div className="profile-dropdown" ref={profileRef}>
          <div className="profile-pic-container" onClick={toggleProfileDropdown}>
            {currentUser?.profile_image && !imageError ? (
              <img
                src={currentUser.profile_image}
                alt="Profile"
                className="profile-pic"
                onError={(e) => {
                  console.error("Gagal memuat foto profil:", e.target.src);
                  setImageError(true);
                  e.target.style.display = "none";
                }}
              />
            ) : (
              <div className="profile-fallback">
                {currentUser?.name ? currentUser.name.charAt(0).toUpperCase() : "U"}
              </div>
            )}
          </div>

          {/* Dropdown Content */}
          {showProfile && (
            <div className="profile-dropdown-content">
              <Profile logout={handleLogout} onMenuClick={() => setShowProfile(false)} />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
